import isArray from 'lodash/isArray';
export const required = (value) => {
    if (value === '' || value === undefined || value === null) {
        return { message: 'Required.' };
    }
    if (isArray(value) && value.length === 0) {
        return { message: 'Required.' };
    }
};
//# sourceMappingURL=required.js.map